import React from "react";
import {
  Datagrid,
  List,
  Filter,
  SearchInput,
  useTranslate,
  Pagination,
  useRecordContext,
} from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import { capitalizeWords } from "../mixins/utils";
import "../assets/styles/UserPagination.css";
import ActivatedBooleanField from "./custom/field/ActivatedBooleanField";
import UserListActions from "./UserListActions";

const useStyles = makeStyles(theme => ({
  small: {
    height: "40px",
    width: "40px",
  },
  large: {
    height: "120px",
    width: "120px",
    float: "right",
  },
  capitalized: () => ({
    textTransform: "capitalize",
  }),
  center: () => ({
    width: "fit-content",
    height: "fit-content",
    position: "absolute",
    zIndex: "99",
    top: "50%",
    left: "50%",
  }),
  visible: () => ({
    width: "100%",
  }),
  blurred: () => ({
    width: "100%",
    filter: "blur(10px)",
  }),
  column: () => ({
    display: "flex",
    flexDirection: "column",
    width: "fit-content",
  }),
  greenStyle: () => ({
    color: "green",
  }),
  redStyle: () => ({
    color: "red",
  }),
  permissionsWrapper: () => ({
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    margin: "1rem",
  }),
  modalTitles: () => ({
    fontFamily: theme.typography.fontFamily,
  }),
}));

export const UserPagination = props => {
  const t = useTranslate();

  return (
    <Pagination
      {...props}
      rowsPerPageOptions={[
        { value: 10, label: "10" },
        { value: 25, label: "25" },
        { value: 50, label: "50" },
        { value: 100, label: "100" },
        { value: 500, label: "500" },
        { value: 1000, label: "1000" },
        { value: 100000, label: t("resources.users.show_all") }, // You can customize the label for "Show All"
      ]}
    />
  );
};

const UserFilter = props => {
  const t = useTranslate();

  return (
    <Filter {...props}>
      <SearchInput
        source="name"
        alwaysOn
        placeholder={t("resources.users.search_placeholder")}
      />
    </Filter>
  );
};

export const CustomTextField = ({ source, property }) => {
  const record = useRecordContext();
  return (
    <span style={{ color: record[property] && "grey" }}>
      {record && capitalizeWords(record[source])}
    </span>
  );
};

export const UserList = props => {
  const classes = useStyles();
  const t = useTranslate();
  return (
    <List
      {...props}
      filters={<UserFilter />}
      sort={{ field: "name", order: "ASC" }}
      actions={<UserListActions maxResults={10000} />}
      bulkActionButtons={false}
      pagination={<UserPagination />}
    >
      <Datagrid rowClick="edit">
        <CustomTextField
          property="deactivated"
          label={t("resources.users.fields.username")}
          source="username"
          sortBy="name"
        />
        <CustomTextField
          property="deactivated"
          label={t("resources.users.fields.first_name")}
          source="first_name"
          sortBy="displayname"
          className={classes.capitalized}
        />
        <CustomTextField
          property="deactivated"
          label={t("resources.users.fields.last_name")}
          source="last_name"
          sortBy="last_name"
          className={classes.capitalized}
        />
        <CustomTextField
          property="deactivated"
          label={t("resources.users.fields.role")}
          source="role"
          sortBy="role"
          className={classes.capitalized}
        />
        <CustomTextField
          property="deactivated"
          label={t("resources.users.fields.displayname")}
          source="displayname"
          sortBy="name"
          className={classes.capitalized}
        />
        <ActivatedBooleanField
          source="mebis_deactivated"
          label={t("resources.users.fields.activated")}
          sortBy="deactivated"
          property={"deactivated"}
        />
      </Datagrid>
    </List>
  );
};

export function generateRandomUser() {
  const homeserver = localStorage.getItem("home_server");
  const user_id =
    "@" +
    Array(8)
      .fill("0123456789abcdefghijklmnopqrstuvwxyz")
      .map(
        x =>
          x[
          Math.floor(
            (crypto.getRandomValues(new Uint32Array(1))[0] /
              (0xffffffff + 1)) *
            x.length
          )
          ]
      )
      .join("") +
    ":" +
    homeserver;

  const password = Array(20)
    .fill(
      "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz~!@-#$"
    )
    .map(
      x =>
        x[
        Math.floor(
          (crypto.getRandomValues(new Uint32Array(1))[0] / (0xffffffff + 1)) *
          x.length
        )
        ]
    )
    .join("");

  return {
    id: user_id,
    password: password,
  };
}
